import { Stack, Text } from '@fluentui/react';
import React, { useMemo } from 'react';

const UserMenuDropdownItem = (props) => {

    // PROPS
    const {
        disabled = false,
        lotCommercial = { numero: undefined, nomCommercial: undefined },
        onClick = undefined // (idOperation, idLotCommercial) => null
    } = props;

    // MEMOS
    const { numero, nomCommercial } = lotCommercial;

    const _styles = useMemo(() => {
        return {
            option: {
                root: {
                    minHeight: 62,
                    paddingLeft: 24,
                    paddingRight: 24,
                    selectors: {
                        "&:hover": {
                            borderLeft: disabled ? "none" : "2px solid red",
                            cursor: disabled ? "unset" : "pointer",
                            paddingLeft: disabled ? 24 : 22
                        },
                        "&:last-child > span": { borderBottom: "none" }
                    }
                }
            },
            optionText: {
                root: {
                    alignItems: "center",
                    borderBottom: "1px solid #DADADA",
                    color: disabled ? "lightgrey" : "#8A8A8A",
                    display: "flex",
                    flexGrow: 1,
                    fontSize: 16,
                    fontWeight: 400,
                    height: "100%",
                    lineHeight: "15px",
                    paddingLeft: 48,
                    paddingRight: 48,
                }
            }
        }
    }, [disabled]);

    return <Stack
        onClick={disabled ? undefined : onClick}
        styles={_styles.option}
        verticalAlign="center"
    >
        <Text styles={_styles.optionText}>
            {[numero, nomCommercial].join(" - ")}
        </Text>
    </Stack>;

};

export default UserMenuDropdownItem;